import { Link, useNavigate } from 'react-router-dom'
import './Contract.css'
import { useEffect, useState } from 'react'
import {notification } from 'antd';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import {Skeleton} from 'antd';
import Select from 'react-select';
const states = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
  "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
  "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
  "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
  "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma",
  "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas",
  "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
];
const stateOptions = states.map(state => ({ value: state, label: state }));

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: '9px',
    height: '51px',
    border: state.isFocused ? '1px solid rgba(0, 0, 0, 0.42)' : '1px solid rgba(0, 0, 0, 0.42)',
    boxShadow: state.isFocused ? '1px solid rgba(0, 0, 0, 0.42)' : 'none',
    color:"black",
    fontWeight:"450"
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: 'black', // Set arrow color
    borderRight: 'none', // Remove the border to the right of the arrow
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#2a4764' : 'white', // Set background color for selected option
    color: state.isSelected ? 'white' : 'black', // Set text color for selected option
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'black', // Set text color for the selected value
  }),
};
function Contract(){
  const navigate = useNavigate()
    const [name, setName] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [licenseState, setLicenseState] = useState('');
    const [licenseNumber, setLicenseNumber] = useState('');
    const [licenseExpDate, setLicenseExpDate] = useState('');
    const [emergencyContact, setEmergencyContact] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
   const [loading ,setLoading]=useState(true)
   const [file, setFile]=useState("")
   const [zip, setZip] = useState("")
   const [city, setCity] = useState("")
   const [pdata, setPdata] = useState("")




   useEffect(() => {
    const localdata = localStorage.getItem("userdata");
    if (localdata != null) {
      const pdatas = JSON.parse(localdata);
      setPdata(pdatas);
      setName(pdatas.name);
      setDateOfBirth(pdatas.dateOfBirth);
      setEmail(pdatas.email);
      setPhone(pdatas.phone);
      setAddress(pdatas.address);
      setLicenseState(pdatas.licenseState);
      setLicenseNumber(pdatas.licenseNumber);
      setLicenseExpDate(pdatas.licenseExpDate);
      setSelectedFile(pdatas.selectedFile);
    }
  }, []);
  
  const handleFileChange = async (e) => {
    setLoading(false);
  
    const file = e.target.files[0];
  
    if (file) {
      // Check if the file type is allowed (png, jpg, jpeg)
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
  
      if (allowedTypes.includes(file.type)) {
        setFile(file);
  
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', 'react cloudinary');
  
        try {
          const response = await fetch('https://api.cloudinary.com/v1_1/dlj1daxbn/image/upload', {
            method: 'POST',
            body: formData,
          });
  
          if (!response.ok) {
            throw new Error('Image upload failed');
          }
  
          const data = await response.json();
          setSelectedFile(data.secure_url);
        } catch (error) {
          console.error('Error uploading image:', error);
          errornoti('error', 'Error uploading image. Please try again.');
        } finally {
          setLoading(true);
        }
      } else {
        console.error('Invalid file type. Please choose a valid image file.');
        errornoti('error', 'Invalid file type. Please choose a valid image file.');
        setLoading(true);
      }
    }
  };
  
  
  const openNotification = (type) => {
    notification[type]({
      message: `${type.charAt(0).toUpperCase() + type.slice(1)} Data Saved`,
      description: `Your Information Is Successfully saved now move to next step choose your plan `,
      duration: 3,
    });
  };
  const errornoti = (type, des) => {
    notification[type]({
      message: `${type.charAt(0).toUpperCase() + type.slice(1)} Invalid`,
      description: des,
      duration: 3,
    });
  };
  
  
  const handleSubmit = async () => {
    // Check if any required field is empty
    if (!name || !dateOfBirth || !email || !phone || !address || !licenseState || !licenseNumber || !licenseExpDate || !emergencyContact || !selectedFile) {
      errornoti("error");
      return;
    }
  
    // Example: Check if the email is valid
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      errornoti('error',"Please Write email correctly");
      return;
    }
  
    // If all checks pass, proceed with form submission
    const formData = {
      name: name,
      dateOfBirth: dateOfBirth,
      email: email,
      phone: phone,
      address: address,
      licenseState: licenseState,
      licenseNumber: licenseNumber,
      licenseExpDate: licenseExpDate,
      emergencyContact: emergencyContact,
      selectedFile: selectedFile
    };
  
    localStorage.setItem("userdata", JSON.stringify(formData));
    openNotification("success");
    navigate("/plan");
  }
  
  const formatPhoneNumber = (input) => {
    const numericInput = input.replace(/\D/g, ''); // Remove non-numeric characters

    if (/^\d{0,10}$/.test(numericInput)) {
      // Limit input to 11 numeric characters
      const formattedNumber = `(${numericInput.slice(0, 3)})-${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
    setEmergencyContact(formattedNumber);
    }
  };
  
  const formatcontactNumber = (input) => {
    const numericInput = input.replace(/\D/g, ''); // Remove non-numeric characters

    if (/^\d{0,10}$/.test(numericInput)) {
      // Limit input to 11 numeric characters
      const formattedNumber = `(${numericInput.slice(0, 3)})-${numericInput.slice(3, 6)}-${numericInput.slice(6)}`;
    setPhone(formattedNumber);
    }
  };
  const searchOptions = {
    componentRestrictions: { country: 'us' }, 
};
  const handleSelect = async (value) => {
    try {
      const results = await geocodeByAddress(value);
      const latLng = await getLatLng(results[0]);
  
      // Access city, state, and zip code from the first result
      const addressComponents = results[0].address_components;
  
      // Log address components for debugging
      console.log('Address Components:', addressComponents);
  
      // Try finding city, state, and zip code with alternative types
      const cityComponent = addressComponents.find(
        (component) => component.types.includes('locality')
      );
      const streetnum = addressComponents.find(
        (component) => component.types.includes("street_number")
      );
      const route = addressComponents.find(
        (component) => component.types.includes("route")
      );
  
      // Log streetnum and route for debugging
      console.log('Street Number Component:', streetnum);
      console.log('Route Component:', route);
  
      const stateComponent = addressComponents.find(
        (component) => component.types.includes('administrative_area_level_1')
      );
  
      const countryComponent = addressComponents.find(
        (component) => component.types.includes('country')
      );
  
      const zipCodeComponent = addressComponents.find(
        (component) =>
          component.types.includes('postal_code') ||
          component.types.includes('postal_code_suffix') ||
          component.types.includes('postal_code_prefix')
      );
  
      const streetAddress = results[0].formatted_address;
  
      const city = cityComponent ? cityComponent.long_name : '';
      const state = stateComponent ? stateComponent.long_name : '';
      const country = countryComponent ? countryComponent.long_name : '';
      const zipCode = zipCodeComponent ? zipCodeComponent.long_name : '';
  
     // Check if streetnum and route are objects with long_name property before setting address
if (streetnum && streetnum.long_name && route && route.long_name) {
setAddress(`${streetnum.long_name} ${route.long_name} ${city} ${state}`);
} else {
console.error('Street Number or Route is undefined or missing long_name property.');
}

  
      setZip(zipCode);
  
    } catch (error) {
      console.error('Error selecting address:', error);
    }
  };  
  const handleProtect = (selectedOption) => {
    setLicenseState(selectedOption.value);
  };
  console.log(licenseState)
    return(
        <>
        <div className="container">
           
            <p className="cdl">Be part of United CDL</p>
            <p className='new-stage-content'>Complete your registration and start a <span style={{color:"#F2B320"}}> new stage in your life</span></p>
            <div className="tabs">
                <p className="tab-list active1">Registration data</p>
                <p className="dots justify-content-center">....</p>
                <p className="dotsmal">..</p>

                <p className="tab-list notActive">Course</p>
                <p className=" smallscreenitem"></p>

                <p className="dotsgrey">....</p>
                <p className="dotsgreymall">..</p>

                <p className="tab-list notActive">Payment</p>
                <p className=" smallscreenitem"></p>

            </div>
            <form>
            <div className="form-part">
                <div className="row forgap">
                    <div className="col-md-6">
                    <label for="fulname" class="form-label">Full Name</label>
                    <input type="text" class="form-control" value={name} onChange={(e)=>{setName(e.target.value)}} id="fulname" placeholder="Ex. John Doe"/>
                    </div>
                    <div className="col-md-6 marg"><label for="fulname" class="form-label">Date of Birth</label>
                    <input type="date" class="form-control" value={dateOfBirth}  onChange={(e)=>{setDateOfBirth(e.target.value)}} id="fulname" placeholder="Date of Birth"/>
                    </div>
                </div>
                <div className="row forgap">
                    <div className="col-md-6">
                    <label for="fulname" class="form-label">Email</label>
                    <input type="email" class="form-control" value={email} onChange={(e)=>{setEmail(e.target.value)}} id="fulname" placeholder="Ex. meuemail@email.com"/>
                    </div>
                    <div className="col-md-6 marg"><label for="fulname" class="form-label">Phone Number</label>
                    <input
        type="text"
        id="phoneNumber"
        className='form-control'
        value={phone}
        placeholder='(XXX)-XXX-XXXX'
        onChange={(e) => formatcontactNumber(e.target.value)}
      /> 
                    </div>
                </div>
                <div className="row forgap">
                    <div className="col-md-6 ">
                    <label for="fulname" class="form-label">Address</label>
                    <PlacesAutocomplete
                                value={address}
                                class="form-control"
                                onChange={(value) => setAddress(value)}
                                onSelect={handleSelect}
                                searchOptions={searchOptions}
                            >
                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                    <div>
                                        <input
                                            {...getInputProps({
                                                placeholder: 'Ex. 66 Waverly Dr',
                                                className: 'form-control form-control-lg full-field',
                                            })}
                                        />
                                        <div className="suggestions-container">
                                            {loading && <div> <Skeleton active /></div>}
                                            {suggestions.map((suggestion) => (
                                                <div className='suggestion' key={suggestion.placeId} {...getSuggestionItemProps(suggestion)}>
                                                    {suggestion.description}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </PlacesAutocomplete>
                    </div>
                    <div className="col-md-6 marg"><label for="fulname" class="form-label">License State</label>
                    {/* <input type="text" value={licenseState}  onChange={(e)=>{setLicenseState(e.target.value)}} class="form-control" id="fulname" placeholder="License State"/> */}
                    <Select
      options={stateOptions}
      styles={customStyles}
      onChange={handleProtect}
      required
    />
                    </div>
                </div>
                <div className="row forgap">
                    <div className="col-md-6">
                    <label for="fulname" class="form-label">License Number</label>
                    <input type="text" value={licenseNumber}  onChange={(e)=>{setLicenseNumber(e.target.value)}} class="form-control" id="fulname" placeholder="Ex. M1234567897"/>
                    </div>
                    <div className="col-md-6 marg"><label for="fulname" class="form-label">License Exp Date</label>
                    <input type="date" value={licenseExpDate}  onChange={(e)=>{setLicenseExpDate(e.target.value)}} class="form-control" id="fulname" placeholder="License Exp Date"/>
                    </div>
                </div>
                <div className="row forgap">
                    <div className="col-md-6">
                    <label for="fulname" class="form-label">Emergency Contact:</label>
                    <input
        type="text"
        id="phoneNumber"
        className='form-control'
        value={emergencyContact}
        placeholder='(XXX)-XXX-XXXX'
        onChange={(e) => formatPhoneNumber(e.target.value)}
      />      
      
                    </div>
                    <div className="col-md-6 marg"><label for="fulname" class="form-label">Scan License</label>
                    <div className="form-control justify-content-end">
                    {file && (
        <span style={{ marginLeft: '10px' }}>{file.name}</span>
      )}
      <label htmlFor="file-upload" className="custom-file-upload">
     
        <b>Attach</b>
      </label>
      <input
        type="file"
        onChange={handleFileChange}
        id="file-upload"
        style={{ display: 'none' }}
      />
     
    </div>
                    </div>
                </div>
                <div className="row forgap">
                    <div className="col-md-6"></div>
                    <div className="col-md-6">
                    <div class="form-control last-btn" onClick={handleSubmit}>
                        <p className='last-btn-text'>
                          {
                            loading?(
                                "Select the course you want to take"
                            ):(
                              "Loading....."
                            )
                          }
                        </p>
                    <i class="fa-solid fa-arrow-right"></i>
                    </div>
                    <div class="form-control last-btns" onClick={handleSubmit}>
                        <p className='last-btn-text'>
                          {
                            loading?(
                                "Select the course"
                            ):(
                              "Loading....."
                            )
                          }
                        </p>
                    <i class="fa-solid fa-arrow-right"></i>
                    </div>
                    </div>
                </div>
            </div></form>
        </div>
        </>
    )
}
export default Contract